import React from 'react';

interface SpinnerProps {
    className?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({ className }) => {
    return (
        <div className="flex justify-center items-center">
            <div className={`animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 ${className || ''}`}></div>
        </div>
    );
}; 